import { type ReactNode } from "react"

export const Main = ({
  children,
}: {
  className?: string
  children: ReactNode
}) => <div className="main">{children}</div>
